module.exports = __webpack_public_path__ + "81aed9c795fac1a95bf73c6528fef63a.jpg";